import React from "react";
import { Section, Overline, H1, H2 } from "@/components/ui-kit";

export default function Privacy() {
  return (
    <Section className="pt-20 md:pt-28 pb-24">
      <Overline>Privacy Policy</Overline>
      <H1 className="mt-4">Privacy Policy</H1>
      <div className="prose prose-invert max-w-3xl mt-10 space-y-6 text-neutral-300 text-sm leading-relaxed">
        <p>Bright Side Capital Ventures LLC ("we", "us") respects your privacy. This page describes how we collect and use information you provide through this website.</p>
        <H2 className="text-lg">Information We Collect</H2>
        <p>We collect information you submit through forms (name, email, phone, property details, capital range, buy criteria, uploaded files) and basic analytics data such as IP address and pages visited.</p>
        <H2 className="text-lg">How We Use Information</H2>
        <p>To respond to your inquiry, route the appropriate next step (purchase evaluation, investor follow-up, buyer match), and improve our website. We do not sell personal information.</p>
        <H2 className="text-lg">Sharing</H2>
        <p>We may share submitted information with service providers used in our workflow (e.g., CRM, email, analytics) under reasonable confidentiality expectations.</p>
        <H2 className="text-lg">Your Choices</H2>
        <p>You may request deletion of your information by emailing acquisitions@brightsidecapital.net.</p>
        <p className="text-xs text-neutral-500 pt-8">This page is a general informational policy. Update or replace with your jurisdiction-specific policy as needed.</p>
      </div>
    </Section>
  );
}
